/**
 * С-I3 Р.1, круг 1 гейта (UI и UX, MAJOR) — компания сменилась из-за отзыва доступа: один спокойный
 * тост называет, к чему доступ отключён и где человек теперь.
 *
 * Два пути ведут сюда: фоновый запрос получил 403 `ENTITY_FORBIDDEN` (обработчик провайдера
 * перечитал профиль) и загрузка страницы, на которой сохранённая компания уже недоступна
 * (`staleStoredId` стора). В режиме компании оба срабатывают на один отзыв — тост один на компанию
 * в окне 10 с. Без этого компания пропадала молча, в «Все компании» и в холдинге — тоже.
 */
import * as m from '@staiter/i18n';
import { emitToast } from '~/components/feedback';

const recent = new Map<string, number>();
const WINDOW_MS = 10_000;

export function noticeEntityRevoked(
  revokedId: string | null,
  fromName: string | null,
  toName: string | null,
): void {
  const key = revokedId ?? fromName ?? '';
  const now = Date.now();
  if ((recent.get(key) ?? 0) > now - WINDOW_MS) return;
  recent.set(key, now);
  // Смена компании перемонтирует дерево провайдеров вместе с `ToastProvider` (свежий QueryClient,
  // ключ эпохи): тост, выпущенный до перемонтирования, пропадал. Показываем после него.
  setTimeout(() => {
    emitToast({
      variant: 'info',
      title: fromName
        ? m.access_entity_revoked_title({ name: fromName })
        : m.access_entity_revoked_title_generic(),
      ...(toName ? { description: m.access_entity_revoked_switched({ name: toName }) } : {}),
      // Человек должен успеть прочитать, где он теперь: короткий тост пропадал раньше, чем его замечали.
      durationMs: 10_000,
    });
  }, REMOUNT_DELAY_MS);
}

const REMOUNT_DELAY_MS = 500;

/** Только для тестов. */
export function __resetEntityRevokedNotice(): void {
  recent.clear();
}
